import { render, staticRenderFns } from "./HistoryTable.vue?vue&type=template&id=d5dbef0c"
import script from "./HistoryTable.vue?vue&type=script&lang=ts"
export * from "./HistoryTable.vue?vue&type=script&lang=ts"
import style0 from "./HistoryTable.vue?vue&type=style&index=0&id=d5dbef0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports